import Vue from 'vue'
import store from "@/store"

var UserInvitePromptContent = Vue.extend({
  template: `
  <div>
    <user-invite
      ref="invite"
      class="m-2"
      :invitation-type="type"
      :invitation-payload="payload" />
  </div>
  `,
  props: {
    type: { default: 'Goal' },
    payload: {},
  },
  beforeCreate() {
    this.$store = store;
  },
  methods: {
    reset() {
      this.$refs.invite.reset();
    }
  }
})

export default {
  methods: {

    $invite_prompt_goal({ title, goalId, cachedName, cachedPicture } = {}) {
      let payload = { goalId, cachedName, cachedPicture }
      this.$invite_prompt({ type: 'goal', payload: payload });
    },

    $invite_prompt({ type, title, payload = {} } = {}) {
      return new Promise((resolve, reject) => {

        this.$msgbox({
          title: '', // title || 'Invite to ' + type,
          message: this.$createElement(UserInvitePromptContent, {
            props: { payload: payload, type: type }
          }),
          showCancelButton: true,
          showConfirmButton: false,
          beforeClose: (action, instance, done) => {
            let dataContainer = instance.$children.find( child => 'payload' in child )
            dataContainer.reset();

            done();
            resolve()
          }
        }).catch(e => e);
      })
    }
  }
}

/*
<!-- TODO: Move to component -->
<portal to="modal-target-goal-details">
  <el-dialog
    class="dialog-small"
    title="Invite to Goalpilot"
    :visible.sync="invite_dialog_visible">

    <user-invite
      headline=""
      invitation-type="Goalpilot"
      :invitation-payload="{}" />

  </el-dialog>
</portal>
*/
